/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import {
  main,
  mainRaised,
  mainRaised2,
  largeLandscape,
  smallLandscape,
  tallPortrait,
  xTallPortrait,
  shortPortrait,
} from "assets/jss/material-kit-pro-react.jsx";

const brand = {
  color: "#FFFFFF",
  textAlign: "left",
  "& h1": {
    "@media (orientation: portrait)": {
      fontSize: "9vh",
    },
    fontSize: "7vw",
    fontFamily: "Raleway",
    display: "inline-block",
    position: "relative",
    marginBottom: "10px",
  },
  "& h2": {
    "@media (orientation: portrait)": {
      fontSize: "5vh",
    },
    fontSize: "4.75vw",

    fontFamily: "Raleway",
    lineHeight: "120%",
    paddingTop: "30px",
    position: "relative", // zIndex only works for positioned element
    marginTop: "0",
    zIndex: "5",
  },
};

const showFor1024Up = {
  "@media (min-width: 1024px)": {
    display: "inline-block",
  },
  display: "none",
};

const showFor1023Down = {
  "@media (max-width: 1023px)": {
    display: "inline-block",
  },
  display: "none",
};

const showFor1600Up = {
  "@media (min-width: 1600px)": {
    display: "inline-block",
  },
  display: "none",
};

const showFor1599Down = {
  "@media (max-width: 1599px)": {
    display: "inline-block",
  },
  display: "none",
};

const pageContent = {
  [largeLandscape]: {
    ...mainRaised,
  },
  ...main,
};

// for Landing Page
const fullPageContent = {
  ...mainRaised2,
  ...main,
};

export {
  brand,
  showFor1024Up,
  showFor1023Down,
  showFor1600Up,
  showFor1599Down,
  pageContent,
  fullPageContent,
};
